import { BookingRecordDetailsCustomer } from '@navio/nsdk';
import { NoddiDateFormats, noddiFormatDate } from '../date/date';

/**
 * Gets the appropriate time display text for a booking based on priority:
 * 1. If communicatedArrivalStart and communicatedArrivalEnd are set, show that
 * 2. If not, show the delivery window start and end times
 *
 * @param booking - The booking record
 * @returns Formatted time string in "15:00 - 16:00" format
 */
export const getBookingTimeDisplayText = (booking: BookingRecordDetailsCustomer): string => {
  // Priority 1: If communicatedArrivalStart and communicatedArrivalEnd are set
  if (booking.communicatedArrivalStart && booking.communicatedArrivalEnd) {
    const startTime = noddiFormatDate(booking.communicatedArrivalStart, NoddiDateFormats.TIME);
    const endTime = noddiFormatDate(booking.communicatedArrivalEnd, NoddiDateFormats.TIME);
    return `${startTime} - ${endTime}`;
  }

  // Priority 2: Show delivery window start and end times
  const startTime = noddiFormatDate(booking.deliveryWindowStartsAt, NoddiDateFormats.TIME);
  const endTime = noddiFormatDate(booking.deliveryWindowEndsAt, NoddiDateFormats.TIME);
  return `${startTime} - ${endTime}`;
};
